export default {
  Form_Common: {
    ZhuShuShi: '主訴及現病史',
    MaiZhen: '脈診',
    SheZhen: '舌診',
    BingMing: '病名',
    ZhengXing: '證型',
    ZhiZeZhiFa: '治則治法',
    YaoPingZhiXingBiaoZhun: '藥品執行標準',
    BaoCi: '包/次',
    KeBao: '克/包',
    MiaoShu: '描述',
    YinPian_FenLiang: '飲片分量',
    RiQi: '日期',
    ZhangHao: '賬號',
    MiMa: '密碼',
    QingShuRu: '請輸入',
    QingXuanZe: '請選擇',
    XingMing: '姓名',
    ZhiGong_LeiBie: '職工類別',
    YiShi: '醫師',
    HuShi: '護士',
    HuShi_Shi: '護師',
    YaoJiShi: '藥劑師',
    QiTa: '其他',
    ZhengJian_LeiXing: '證件類型',
    JuMin_ShenFenZheng: '居民身份證',
    JuMin_HuKouBu: '居民戶口簿',
    HuZhao: '護照',
    JunGuan_Zheng: '軍官證',
    JiaShi_Zheng: '駕駛證',
    GangAo_TongXingZheng: '港澳居民來往内地通行證',
    TaiWan_TongXingZheng: '台灣居民來往内地通行證',
    ChuSheng_YiXue_ZhengMing: '出生醫學證明',
    ZhengJian_HaoMa: '證件號碼',
    ZhongWen_XingMing: '中文姓名',
    YingWen_XingMing: '英文姓名',
    DiQu: '地區',
    DiZhi: '地址',
    XiangXi_DiZhi: '詳細地址',
    ZhaoPian: '照片',
    MiaoShu_Text: '描述',
    ZhengShu: '證書',
    ZhengShu_BianHao: '證書編號',
    ZhengShu_MingCheng: '證書名稱',
    FaZheng_ShiJian: '發證時間',
    YouXiao_Qi: '有效期',
    FuJian: '附件',
    PaiBan: '排班',
    Bu_PaiBan: '不排班',
    JueSe_Ming: '角色名',
    JueSe_MiaoShu: '角色描述',
    QuanXuan: '全選',
    ShiFou_PeiSong: '是否配送',
    YouFei: '郵費',
    Xian_JiuZhen_Hou_FuKuan: '先就診後付款',
    ZhiFu_FangShi: '支付方式',
    XianShang_ZhiFu: '線上支付',
    XianXia_ZhiFu: '線下支付',
    YiBao: '醫保',
    Bao: '包',
    Ci: '次',
    Ke: '克',
    YaoPin_ZhongLiang: '藥品重量',
    WuCha: '誤差',
    AnZhao_BiLi_JiSuan: '按照比例計算',
    KaiShi_Zhi: '開始值',
    JieShu_Zhi: '結束值',
    ShiFou_YongHu_Quan: '是否用戶券',
    ShiFou_GuoQi: '是否過期',
    LeiBie: '類別',
    ZheKou_Quan: '折扣券',
    ManJian: '滿減',
    DaiJin_Quan: '代金券',
    YouHuiQuan: '優惠券',
    YiLiao_Quan: '醫療券',
    TaoPiao: '套票',
    Zi_Medicine: '藥',
    Zi_Acupuncture: '針',
    Zi_Img: '影',
    Zi_Postage: '郵',
    Zi_Fee: '診',
    Zi_Massage: '推',
    Zi_Cupping: '拔',
    QiYong: '啟用',
    TingYong: '停用',
    Zhe: '折',
    YouHuiQuan_LeiXing: '優惠券類型',
    ShiLi: '示例',
    ZheKou: '折扣',
    ShiYong_FanWei: '使用範圍',
    ChuFang_Dan: '處方單',
    ZhenJiu_Dan: '針灸單',
    WenDang_YingXiang_Dan: '文檔影像單',
    LingShou: '零售',
    OTC: 'OTC',
    KuaiDi_Dan: '快遞單',
    TuiNa_ZhengGu: '推拿/正骨',
    BaGuan: '拔罐',
    ShengShi_Qu: '省市區',
    JieShao_TuJing: '介紹途徑',
    PengYou: '朋友',
    ChuanDan: '傳單',
    BaoZhi_ZaZhi: '報章雜誌',
    HuLianWang: '互聯網',
    DianYou: '電郵',
    ChuFang_GongKai: '處方公開',
    ShiYong_YiLiao_Quan: '使用醫療券',
    YaoPin_JiSuan_GuiGe: '藥品計算規格',
    CaoYao: '草藥',
    NongSuo_Yao: '濃縮藥',
    YaoPin_ZhiXing_BiaoZhun: '藥品執行標准',
    DiZhi_XinXi: '地址信息',
    ShouHuoRen_XingMing: '收貨人姓名',
    ZhiFu_QuDao: '支付渠道',
    YiLiao_Quan_Item: '醫療券',
    MeiTuan: '美團',
    ChuZhi_Ka: '儲值卡',
    YaoPin_MingCheng: '藥品名稱',
    YaoPin_BianMa: '藥品編碼',
    PinPai: '品牌',
    You_Wu_KuCun: '有無庫存',
    You_KuCun: '有庫存',
    Wu_KuCun: '無庫存',
    ShiFou_QiYong: '是否啟用',
    ZuiXiao_YuJing_Liang: '最小預警量',
    ZuiDa_YuJing_Liang: '最大預警量',
    DingDan_BianHao: '訂單編號',
    DingDan_ShiJian: '訂單時間',
    ZhuangTai: '狀態',
    BeiZhu: '備註',
    ShenHe_JieGuo: '審核結果',
    TongGuo: '通過',
    Bu_TongGuo: '不通過',
    ShenPi_YiJian: '審批意見',
    QianShou_Ren: '簽收人',
    QuanBu_YaoPin: '全部藥品',
    DiaoZheng_ShiJian: '調整時間',
    DianZi_QianMing: '電子簽名',
    MingCheng: '名稱',
    YaoWu_JiFei: '藥物計費',
    ZhenJiu_FeiYong: '針灸費用',
    LingShou_JiFei: '零售計費',
    ChongZhi: '充值',
    TaoPiao_JiFei: '套票計費',
    TuiNa_FeiYong: '推拿費用',
    BaGuan_FeiYong: '拔罐費用',
    ZhongLei: '種類',
    JiChu: '基礎',
    ChengBen: '成本',
    JiFei: '計費',
    TianShu: '天數',
    ShouJia: '售價',
    YongLiang: '用量',
    TuXiang: '圖像',
    Zi_Product: '售',
    Zi_Ticket: '票',
    ShouFei_LeiBie: '收費類別',
    JiFei_ZhongLei: '計費種類',
    JiFei_FangFa: '計費方法',
    NongSuo_Yao_SheDing: '濃縮藥設定',
    MoRen: '默認',
    YinPian_SheDing: '飲片設定',
    JiBen_ShouFei: '基本收費',
    MeiTian_ShouFei: '每天收費',
    NongSuo_Yao_MeiTian_ShouFei: '濃縮藥每天收費',
    YinPian_MeiTian_ShouFei: '飲片每天收費',
    ShouFei_XiangMu: '收費項目',
    YuShe_ShouFei: '預設收費',
    YingWen_MingCheng: '名稱英文',
    NianLing: '年齡',
    ZuBie: '組別',
    Bu_XianShi: '不顯示',
    ChuFang_NianLing_XianShi: '處方年齡顯示',
    KaiShi_Zhi_Short: '開始值',
    JieShu_Zhi_Short: '結束值',
    Sui: '歲',
    Ke_BianJi: '可編輯',
    JiBie: '級別',
    YouHui: '優惠',
    QiBu_JinE: '起步金額',
    KaPian_MingCheng: '名稱',
    YuYue_RiQi: '預約日期',
    JinE: '金額',
    HuoDong_MingCheng: '活動名稱',
    KaiShi_ShiJian: '開始時間',
    JieShu_ShiJian: '結束時間',
    ZuMing_Cheng: '名稱',
    XiangQing: '詳情',
    ChaoShou: '超收',
    MianShou_XianDing_ChengBen_JinE: '免收限定成本金額',
    JiaShou_JinE: '加收金額',
    YiShi_LeiXing: '醫師類型',
    ZhuCe_YiShi: '註冊醫師',
    BiaoLie_YiShi: '表列醫師',
    ChuZhiKa_ChongZhi: '儲值卡充值',
    KeHu_JieShou_TuiGuang: '客人接受推廣',
    DuiZhang_ShiJian: '對賬時間',
    DingDan_Shu: '訂單數',
    ShangPin_ZhuangTai: '商品狀態',
    ShangPin_MingCheng: '商品名稱',
    QiTa_LianXi_FangShi: '其他聯繫方式',
    An_Ri: '按日',
    An_Yue: '按月',
    DingDan_LaiYuan: '訂單類型',
    Wei_ZhiFu: '未支付',
    Dai_TiHuo: '待提貨',
    Yi_WanCheng: '已完成',
    TuiDan: '退单',
    ZuoFei: '作廢',
    YiShi_XingMing: '醫師姓名',
    ShiFou_PaiBan: '是否排班',
    YaoPin_DaBao: '藥品打包',
    An_XiaoLv: '按效率',
    An_JingDu: '按精度',
    XiangMu_JiaGe: '項目價格',
    XiangMu_MiaoShu: '項目描述',
    XiangMu_ShiJian: '項目時間',
    GuanLian_XiangMu: '關聯項目',
    TaoPiao_MingCheng: '套票名稱',
    ShiFou_GuoQi_Short: '是否过期',
    GuoQi: '過期',
    Wei_GuoQi: '未過期',
    PaiXu_XuHao: '排序序號',
    ZhenZheng_Xu_Shu_Ru_ZiLiao: '診症需輸入資料',
    SuoYou_LanWei: '所有欄位',
    DanWei: '藥品單位',
    ShuRu_DanWei: '輸入單位',
    ChuFang_DanWei: '處方單位',
    YaoPin_PaiXu: '藥品排序',
    ShuRu: '輸入',
    DaYin_LeiXing: '打印類型',
    Mei_Jie_ShiJian: '每節時間',
    ShengCheng_HaoYuan_TianShu: '生成號源天數',
    GuiZe_MingCheng: '規則名稱',
    YouXiao_RiQi: '有效日期',
    QuanBu: '全部',
    YingYe_ShiJian: '營業時間',
    XingQi: '星期',
    HaoYuan: '號源',
    PaiBan_Rules: '排班',
    ShuoMing: '說明',
    ShuoMing_En: '說明(En)',
    BingRen_XingMing: '病人姓名',
    Ming_En: '名(En)',
    Xing_En: '姓(En)',
    ZhenSuo_ZhuanTai: '診所狀態',
    ZhenSuo_BianMa: '診所編碼',
    ZhenSuo: '診所',
    KaiMen_ShiJian: '開門時間',
    GuanMen_ShiJian: '關門時間',
    ZhenSuo_MinCheng: '診所名稱',
    YingWen_MinCheng: '英文名稱',
    YingWen_DiZhi: '英文地址',
    JingWeiDu: '經緯度',
    ZhenSuo_Logo: '診所Lgo',
    ZhenSuo_ZhaoPian: '診所照片',
    YouWu_Biaozhun: '有無標準',
    YaoPin_YingWen_MingCheng: '藥品英文名稱',
    ShiFou_FuFangYao: '是否復方藥',
    GongNeng: '功能',
    GuiGe_YingWen: '英文規格',
    ChengFen_JiSuanLiang: '成分計算量',
    ZhuCe_BianMa: '註冊編碼',
    RuKu_DanWei: '入庫單位',
    RuKu_DanWeiLiang: '入庫單位量',
    AnQuanLiang: '安全量',
    MoRen_DanJia: '默認單價',
    MoRen_ChengBenjia: '默認成本價',
    JiWangShi: '既往史',
  },
}
